import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import '../../index.css';

import { getBotMessagesWithAvg } from '../../../../../../store/actions/reports';
import chatIcon from '../../../../../../assets/images/chat.svg';
import ContainerReport from '../../../ContainerReport';
import { sumReportsArray } from '../../graphic-report-helper';

/**
 * Component for show the bot quantity of messages report
 *
 * @param {*} props
 * @returns
 */
const QntMessageReport = (props) => {
  const {
    match,
    user,
    getBotMessagesWithAvg,
    messagesWithAvg,
    componentData,
    bot
  } = props;

  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { botid } = match.params;
  //const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  const [totalMessage, setTotalMessage] = useState(0);
  const [userTotalMessage, setUserTotalMessage] = useState(0);
  const [averageMessage, setAverageMessage] = useState(0);
  const [timezone, setTimezone] = useState('');

  /**
   * Called for fetch new data for this component
   */

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  },[bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables, startDate, endDate } = parentFilter;
      getBotMessagesWithAvg(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone
      });
    };
  }, [parentFilter, user, timezone]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    setTotalMessage(getPeriodTotalMessages());
    setUserTotalMessage(sumReportsArray(messagesWithAvg.user));
    setAverageMessage(getPeriodAverageMessages());
  }, [messagesWithAvg]);

  /**
   * Get the average message time
   */
  const getPeriodAverageMessages = () => {
    if (
      !messagesWithAvg ||
      !Array.isArray(messagesWithAvg.average) ||
      messagesWithAvg.average.length === 0
    ) {
      return 0;
    }
    return messagesWithAvg.average[0].avg;
  };

  /**
   * Get the total message time
   */
  const getPeriodTotalMessages = () => {
    if (
      !messagesWithAvg ||
      !Array.isArray(messagesWithAvg.total) ||
      messagesWithAvg.total.length === 0
    ) {
      return 0;
    }
    return messagesWithAvg.total[0].count;
  };

  /**
   * Get total of messages received by the bot
   */
  const getReceivedMessages = () => {
    const total = totalMessage - userTotalMessage;
    return total < 0 ? 0 : total;
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{totalMessage}</p>
          <span className="tipo-relatorio">Total</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-green">{userTotalMessage}</p>
          <span className="tipo-relatorio">Recebidas</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-blue">{getReceivedMessages()}</p>
          <span className="tipo-relatorio">Enviadas</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio" style={{ marginTop: 18 }}>
          <p className="result-relatorio-yellow">{averageMessage}</p>
          <span className="tipo-relatorio">
            Média por <br /> Sessão
          </span>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={chatIcon}
      title="Mensagens"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    messagesWithAvg: {
      total: state.reports.botMessagesWithAvg.total,
      bot: state.reports.botMessagesWithAvg.bot,
      user: state.reports.botMessagesWithAvg.user,
      average: state.reports.botMessagesWithAvg.average,
      bot: state.bots.bot
    },
    bot: state.bots.bot
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getBotMessagesWithAvg }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QntMessageReport)
);
